export const selectPoisFromResponse = action => action.payload.data.results;
